(function () {
  'use strict';

  if (window.hdKachelmenue) { return; }
  window.hdKachelmenue = true;

  function vorschauHolen(bereich) {
    var bilder = bereich.querySelectorAll('img.hd-km__vorschau[data-src]');
    for (var i = 0; i < bilder.length; i++) {
      var b = bilder[i];
      if (b.dataset.srcset) { b.setAttribute('srcset', b.dataset.srcset); }
      b.setAttribute('src', b.dataset.src);
      b.removeAttribute('data-src');
      b.removeAttribute('data-srcset');
    }
  }

  function einrichten(wurzel) {
    var fenster = wurzel.querySelector('.hd-km__fenster');
    if (!fenster) { return; }

    var knoepfe = document.querySelectorAll('.nav_toggle');
    for (var n = 0; n < knoepfe.length; n++) {
      knoepfe[n].addEventListener('click', function () {
        vorschauHolen(wurzel);
      }, { capture: true, once: true });

      knoepfe[n].addEventListener('pointerdown', function () {
        vorschauHolen(wurzel);
      }, { capture: true, once: true, passive: true });
    }

    function unterebenenHolen(bereich) {
      var bilder = bereich.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < bilder.length; i++) {
        bilder[i].setAttribute('loading', 'eager');
      }
    }

    function imLeerlaufHolen() {
      function alles() {
        vorschauHolen(wurzel);
        unterebenenHolen(fenster);
      }
      function gleich() {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(alles, { timeout: 4000 });
        } else {
          alles();
        }
      }
      window.setTimeout(gleich, 2000);
    }

    if (document.readyState === 'complete') {
      imLeerlaufHolen();
    } else {
      window.addEventListener('load', imLeerlaufHolen, { once: true });
    }

    var kopf = document.querySelector('.mobile-nav__header');
    var titel = kopf ? kopf.querySelector('.mobile-nav__title') : null;
    if (!kopf || !titel) { return; }

    var startTitel = titel.textContent;
    var offen = null;

    var zurueck = document.createElement('button');
    zurueck.type = 'button';
    zurueck.className = 'hd-km__zurueck';
    zurueck.setAttribute('aria-label', 'Eine Ebene zurück');
    zurueck.innerHTML =
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
      ' stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M15 18l-6-6 6-6"/></svg>';
    kopf.insertBefore(zurueck, kopf.firstChild);

    function oeffnen(ziel) {
      var e = fenster.querySelector('[data-hd-ebene="' + ziel + '"]');
      if (!e) { return; }
      e.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { e.classList.add('hd-km--offen'); });
      });
      e.scrollTop = 0;
      offen = e;
      titel.textContent = e.getAttribute('data-hd-name') || startTitel;
      zurueck.classList.add('hd-km--da');
    }

    function schliessen() {
      if (!offen) { return; }
      var e = offen;
      e.classList.remove('hd-km--offen');
      window.setTimeout(function () {
        if (!e.classList.contains('hd-km--offen')) { e.hidden = true; }
      }, 300);
      offen = null;
      titel.textContent = startTitel;
      zurueck.classList.remove('hd-km--da');
    }

    wurzel.addEventListener('click', function (ev) {
      var k = ev.target.closest ? ev.target.closest('[data-hd-ziel]') : null;
      if (!k || !wurzel.contains(k)) { return; }
      ev.preventDefault();
      oeffnen(k.getAttribute('data-hd-ziel'));
    });

    zurueck.addEventListener('click', function (ev) {
      ev.preventDefault();
      schliessen();
    });

    document.addEventListener('click', function (ev) {
      var z = ev.target.closest ? ev.target.closest('.close-menu, .modal-overly') : null;
      if (z) { window.setTimeout(schliessen, 320); }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && offen) { schliessen(); }
    });

    var fuss = wurzel.parentNode ? wurzel.parentNode.querySelector('.hd-km__fuss') : null;
    if (fuss) {
      fuss.addEventListener('change', function (ev) {
        var s = ev.target;
        if (!s || s.tagName !== 'SELECT' || !s.form) { return; }
        if (s.form.dataset.hdGesendet) { return; }
        s.form.dataset.hdGesendet = '1';
        s.form.submit();
      });
    }
  }

  function start() {
    var alle = document.querySelectorAll('.hd-km');
    for (var i = 0; i < alle.length; i++) { einrichten(alle[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
